import { IPayoutTransactionWithCharges, schemes, zSchema } from "@zeal/common";

export const createPayoutRequestSchema = zSchema.object({
  odo_user_id: schemes.mongoOrUuid(),
});

export type TCreatePayoutRequestSchema = zSchema.infer<
  typeof createPayoutRequestSchema
>;

export type TCreatePayoutResponseSchema = IPayoutTransactionWithCharges;
